import { T } from './Translate';
import React, { useState, useEffect } from "react";
import { Typography, AppBar, Toolbar, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { isLoggedIn } from "../session";
import { useNavigate } from "react-router-dom";
import BackButton from "./BackButton";

function ProfileHeader() {
  const { uid } = useParams();
  const [userId, setUserId] = useState(""); // Estado para almacenar el nombre del usuario

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const db = getFirestore();
        const userDocRef = doc(db, "users", uid);
        const userDocSnapshot = await getDoc(userDocRef);

        if (userDocSnapshot.exists()) {
          const userData = userDocSnapshot.data();
          const name = userData.displayName || <T>Usuario</T>; // Asegurando que 'displayName' sea el campo correcto
          setUserId(name);
        } else {
          console.error("No se encontró el usuario.");
        }
      } catch (error) {
        console.error("Error al obtener los datos del usuario:", error);
      }
    };

    if (uid) {
      fetchUserData();
    }
  }, [uid]);

  let navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  }, [navigate]);

  return (
    <AppBar position="fixed">
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            maxWidth: { xs: "100%", md: "980px" },
            mx: "auto",
          }}
        >
          <BackButton />
          {userId && (
            <Typography
              variant="h6"
              sx={{
                paddingLeft: "24px",
                paddingTop: "10px",
                fontSize: "24px",
              }}
              gutterBottom
            >
              {userId}
            </Typography>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default ProfileHeader;
